import './Theme.Button.Tab.scss';
export default `ThemeButtonTab`;
